import React, { useEffect, useState, useMemo, useCallback } from "react";
import { Nav } from "react-bootstrap";
import { useLocation, useNavigate, useParams, useSearchParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { getUrlDetailsObj, getUserStatsObject, recordActivity } from "../../../services/commonService";
import { useUser } from "../../../context/UserContext";
import { COMPANY_LOGO_BASE_URL } from "../../../config/apiConfig";
import { useDispatch } from "react-redux";
import { fetchRevenueAnalysisRequest } from "../../../store/features/actions/fetchRevenueAnalysisAction";
import { fetchReGeoWisevenueAnalysisRequest } from "../../../store/features/actions/fetchGeoWiseRevenueAnalysisAction";
import { fetchCompFinancialRequest } from "../../../store/features/actions/companyFinancialsActions";
import { fetchKeyConversationRequest } from "../../../store/features/actions/keyConversationActions";
import CompanyOverview from "./CompanyOverview";
// import QuestionsPromtersTab from "./Questions/QuestionsPromtersTab";

import CompanyLogoSkeleton from "../skeletons/companyLogoSkeleton";
import { fetchAccountContactRequest } from "../../../store/features/actions/accountContactsActions";
import "./AccountDetailsTabsV2.css"
import MoreComps from "./MoreCompoents/MoreComps";
import TargetedReachOutComp from "./TargetedReachOut/TargetedReachOutComp";
import MaximisePipeComp from "./Opportunities/MaximisePipeComp";
import * as FeatherIcon from "react-feather";
import MeetingPrepComp from "./MeetingPrep/MeetingPrepComp";
import NudgesNewM from "./NudgesAndEvents/NudgesNew/NudgesNewM";
import { addStreamListener, initStreamSW } from "../../../streaming/streamSwClient";
import { updateContactPhoneUpdate } from "../../../store/features/actions/targetedReachout/spotContactsActions";


function AccountDetailsTabsV2() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { user } = useUser();
  // console.log("user",user)
  const location = useLocation(); // Keep location for robust checks
  const { accountId, accountName } = useParams();
  const pageParsedData = getUrlDetailsObj(useLocation, useParams);
  const [searchParams] = useSearchParams();
  const activeTabFromUrl = searchParams.get("tab") || "accountPlan";
  const activeSubTabFromUrl = searchParams.get("subTab");

  const { account_info, account_info_loading } = useSelector(state => state.accountsReducer);
  const { account_contacts, account_contacts_loading } = useSelector(state => state.accountContactsReducer);
  const [activeParentTabKey, setParentActiveTab] = useState(activeTabFromUrl);
  const [accountContactList, setAccountContactList] = useState([]);

 const [currentRoleKey, setCurrentRoleKey] = useState(user?.role_key);
  useEffect(() => {
    /*
    if(user?.id){
      dispatch(fetchDynamicTabsRequest({ clientName, accountName }));
    }
    */
    setCurrentRoleKey(user?.role_key)
  }, [user?.id]);


  
useEffect(() => {
    if (activeTabFromUrl !== activeParentTabKey) {
      setParentActiveTab(activeTabFromUrl);
    }
  }, [activeTabFromUrl]);

useEffect(() => {
  if (account_info?.ticker && user?.id && activeParentTabKey === "accountPlan") {
      dispatch(fetchCompFinancialRequest({ accountName, ticker: account_info?.ticker }));
      
      dispatch(fetchReGeoWisevenueAnalysisRequest({ ticker: account_info?.ticker }));
      // dispatch(fetchSegmentsRequest({ accountName }));
      
      dispatch(fetchRevenueAnalysisRequest({ ticker: account_info?.ticker }));
      dispatch(fetchKeyConversationRequest({ accountName }));
    }

  if (
    accountName &&
    (activeParentTabKey === "business" || activeParentTabKey === "contacts")
  ) {
    if(user?.id){
      dispatch(fetchAccountContactRequest(accountName));
    }
  }
}, [account_info?.ticker, accountName, activeParentTabKey, user?.id]);


  // Finalized Logging Logic (Single source of truth)
  useEffect(() => {
    if(!user?.id){
      return 
    }
    
    // Check 1: Do not log if the URL has no query parameters (i.e., it's the path-only initial load)
    if (!location.search || location.search.length <= 1) { 
        return; 
    }
    
    // Check 2: Wait until the activeParentTabKey state has stabilized from the URL
    if (activeParentTabKey !== activeTabFromUrl) {
        return; 
    }

    // --- Activity Recording Logic ---

    const tabTypeMap = {
      accountPlan: "Account Plan",
      maximise_pipe: "Maximise Pipe",
      business: "Business",
      growth: "Growth Opportunities",
      nudges_new: "Signals",
      documents: "Documents",
      competitor_insights: "Competitor Analysis",
      technology: "Tech Landscape",
      financial: "Financials",
      agents: "Agents",
      targeted_reach_out:"Targeted Reach Out",
      meeting_prep:"Meeting Prep",
      more: "More"
    };

    const subTabTypeMap = {
      // **All MaximisePipe sub-tabs are included here for correct label logging**
      spot_opportunitites: "Spot Opportunities", 
      win_opportunitites: "Win Opportunities", 
      increase_deal_size: "Increase Deal Size", 
      contacts: "Contacts", 
      questions: "Questions",
      // Add other sub-tab mappings here
    };

    let tabLabelToTrack = tabTypeMap[activeParentTabKey];
    
    // Prioritize Sub-Tab if present and mapped
    if (activeSubTabFromUrl && subTabTypeMap[activeSubTabFromUrl]) {
      tabLabelToTrack = subTabTypeMap[activeSubTabFromUrl];
    }
    
    if (tabLabelToTrack) {
      // Set query params for recording
      pageParsedData.query_params = { tab: activeParentTabKey }; 
      if (activeSubTabFromUrl) {
        pageParsedData.query_params.subTab = activeSubTabFromUrl;
      }

      const userStat = getUserStatsObject(
        tabLabelToTrack, 
        "page_load",
        `Page Source: ${accountName}`,
        window.location.href, // Use the full URL for logging
        accountId
      );
      userStat.url_details = pageParsedData;
      recordActivity(userStat);
    }
    
  }, [activeParentTabKey, activeSubTabFromUrl, activeTabFromUrl, user?.id, location.search]);

  useEffect(() => {
    if (user?.company_id && !account_contacts_loading) {
      setAccountContactList(account_contacts || { records: [], filters: {} });
    }
  }, [user?.company_id, account_contacts, account_contacts_loading]);

  const handleTabChange = useCallback((key) => {
    if (
      [
        "accountPlan",
        "business",
        "growth",
        "nudges_new",
        "agents",
        "competitor_insights",
        "technology",
        "financial",
        "documents",
        "maximise_pipe",
        "targeted_reach_out",
        "meeting_prep",
        "more",
      ].includes(key)
    ) {
      setParentActiveTab(key);
    }
  }, []);

       useEffect(() => {
            let removeListener = null;
            debugger
        
            const setup = async () => {
              try {
                await initStreamSW(); // ensure SW is ready
        
                removeListener = addStreamListener((msg) => {
                  if (msg.type === "PHONE_UPDATE") {
                    const key = `${user?.id}_${msg.apolloId}_phone_pending`;
                    localStorage.removeItem(key);
                    dispatch(updateContactPhoneUpdate(msg.apolloId, msg?.phone));
                  }
                  if (msg.type === "PHONE_UPDATE_ERROR") {
                    const key = `${user?.id}_${msg.apolloId}_phone_pending`;
                    localStorage.removeItem(key)
                    dispatch(updateContactPhoneUpdate(msg.apolloId, "Not Found"));
                    console.log("No phone found:", msg.message);
                  }
                });
              } catch (err) {
                console.error("Stream SW init failed:", err);
              }
            };
        
            setup();
        
            return () => {
              if (typeof removeListener === "function") {
                removeListener(); // safely remove listener
              }
            };
          }, []);
   

  const renderContent = () => {
    switch (activeParentTabKey) {
      case "accountPlan":
        return <CompanyOverview active_tab_key={activeParentTabKey} />;
      case "maximise_pipe":
        return <MaximisePipeComp />;  
      case "nudges_new":
        return <NudgesNewM />;
      case "targeted_reach_out":
        return <TargetedReachOutComp/>
      case "meeting_prep":
          return <MeetingPrepComp/>
      case "more":
        return <MoreComps accountContactList={accountContactList}/>;  
      default:
        return null;
    }
  };

  const tabItems = useMemo(() => [
    { key: "accountPlan", label: "Account Plan", icon: <FeatherIcon.Grid className="fa" style={{width:'16px',marginRight:'7px'}} /> },
    { key: "maximise_pipe", label: "Maximise Pipe", icon: <FeatherIcon.Briefcase className="fa" style={{width:'16px',marginRight:'7px'}} /> },
    { key:"targeted_reach_out",label:"Targeted Reach Out", icon: <FeatherIcon.Target className="fa" style={{width:'16px',marginRight:'7px'}} />},
    // { key:"meeting_prep",label:"Meeting Prep", icon: <FeatherIcon.Calendar className="fa" style={{width:'16px',marginRight:'7px'}} />},
    { key: "nudges_new", label: "Signals", icon: <FeatherIcon.Globe className="fa" style={{width:'16px',marginRight:'7px'}} /> },
    { key: "more" , label: "More", icon: <FeatherIcon.Compass className="fa" style={{width:'16px',marginRight:'7px'}} />},
  ], []);

    const handleBackToAccounts = () => {
      console.log("currentRoleKey", currentRoleKey);

      if (currentRoleKey === "SUPER_ADMIN") {
        navigate("/users/user_dashboard");
      } else if (
        currentRoleKey === "CLIENT" ||
        currentRoleKey === "CLIENT_EMPLOYEE"
      ) {
        navigate("/clients_accounts"); 
      } else if (currentRoleKey === "SALES_DEMO" || currentRoleKey === "ANALYST") {
        navigate("/sales_accounts");
      } else {
        // Fallback: send to dashboard if role not matched
        navigate("/clients_accounts");
      }
    };

  return (
    <div className="account-details-container">

        {/* Sidebar */}
        <div className="account-details-container-sidecard-container">
        <div className="sidebar_left_container">
            {account_info_loading ? (
              <CompanyLogoSkeleton />
            ) : (
              <div className="account-logo-name-container">
                <img src="/img/back_top.png" alt="icon" className="back_btn_new_top cursorP" onClick={() => handleBackToAccounts() } />
                <img
                  src={`${COMPANY_LOGO_BASE_URL}${encodeURIComponent(account_info?.name || accountName)}`}
                  alt="Company Logo"
                  className="account-logo-name-img"
                />
                <div className="account-logo-name-txt" title={account_info?.display_name || account_info?.name || accountName}>{account_info?.display_name || account_info?.name || accountName}</div>
              </div>
            )}
        
          <Nav className="account-tabs-nav">
            {tabItems.map((tab) => (
              <Nav.Link
                className="account-tab-item"
                key={tab.key}
                active={activeParentTabKey === tab.key}
                onClick={() => handleTabChange(tab.key)}
              >
                <div className="account-tab-item-content">
                  <span className="icon_left_sub">{tab.icon}</span>  
                  {tab.label}
                </div>
                
              </Nav.Link>
            ))}
          </Nav>
        </div>
        </div>

        {/* Content Area */}
        <div className="account-details-container-content">
          {renderContent()}
        </div>
    </div>
  );
}

export default React.memo(AccountDetailsTabsV2);